module.exports = __webpack_public_path__ + "img/30.07b32fe6.png";